import { Injectable } from '@angular/core';
import { Destination } from '@app/models/destination';
import {
  Load,
  LoadSuccess,
  LoadFail,
  Create,
  CreateSuccess,
  CreateFail,
  AddAll,
  AddOne,
  Delete,
  DeleteFail,
  DeleteSuccess,
  Update,
  UpdateFail,
  UpdateSuccess,
  RemoveOne,
  DestinationActionTypes

} from '@core/actions/destination.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, concatMap } from 'rxjs/operators';
import { DestinationService } from '@app/services/api/destination.service';
import { FlashService } from '@app/services/flash.service';


@Injectable()
export class DestinationEffects {
  @Effect()
  load$: Observable<Action> = this.destination$.pipe(
    ofType<Load>(DestinationActionTypes.Load),
    switchMap(() => {
      return this.destinationApi.get().pipe(
        map((destination: Destination[]) => new LoadSuccess(destination)),
        catchError(error => of(new LoadFail(error)))
      );
    })
  );

  @Effect()
  loadSuccess$: Observable<Action> = this.destination$.pipe(
    ofType<LoadSuccess>(DestinationActionTypes.LoadSuccess),
    map(action => new AddAll(action.destinations))
  );

  @Effect()
  create$: Observable<Action> = this.destination$.pipe(
    ofType<Create>(DestinationActionTypes.Create),
    map(action => action.destinations),
    switchMap(destination =>
      this.destinationApi.create(destination).pipe(
        map((savedDestination:Destination) =>{
          return new CreateSuccess(savedDestination)
        }),
        catchError(error => of(new CreateFail(error)))
      )
    )
  );
  
  @Effect()
  createSuccess$: Observable<Action> = this.destination$.pipe(
    ofType<CreateSuccess>(DestinationActionTypes.CreateSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'destino creado' });
      return new AddOne(action.destinations);
    })
  );

  @Effect()
  delete$: Observable<Action> = this.destination$.pipe(
    ofType<Delete>(DestinationActionTypes.Delete),
    map(action => action.id),
    concatMap((id) =>
      this.destinationApi.delete(id).pipe(
        map(destination => {
          return new DeleteSuccess(destination)
        }),
        catchError(error => of(new DeleteFail(error)))
      )
    )
  );

  @Effect()
  deleteSuccess$: Observable<Action> = this.destination$.pipe(
    ofType<DeleteSuccess>(DestinationActionTypes.DeleteSuccess),
    map(action => {
      this.fs.emit({ type: 'danger', message: 'destino elimindado' });
      return new RemoveOne(action.data);
    })
  );


  @Effect()
  update$: Observable<Action> = this.destination$.pipe(
    ofType<Update>(DestinationActionTypes.Update),
    map(action => [action.id, action.destination]),
    concatMap(([id, destination]) =>
      this.destinationApi.update(id, destination).pipe(
        map(product => { return new UpdateSuccess(product)}),
        catchError(error => of(new UpdateFail(error)))
      )
    )
  );

  @Effect()
  UpdateSuccess$: Observable<Action> = this.destination$.pipe(
    ofType<UpdateSuccess>(DestinationActionTypes.UpdateSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Destino editado' });
      return new Load()
    })
  );
  
  constructor(
    private destination$: Actions,
    private destinationApi: DestinationService,
    private fs: FlashService
  ) {}
}
